// extracted by mini-css-extract-plugin
export default {"main-wrapper":"style_main-wrapper__6yf6d","main":"style_main__VcMZl"};